import { BaseDialog } from './BaseDialog';
import { useTranslation } from '../../store';

export const ImageDialog = ({ 
  isOpen, 
  onClose, 
  titleKey = 'imageTitle', 
  data
}) => {
  const { t } = useTranslation();
    
  return (
    <BaseDialog isOpen={isOpen} onClose={onClose} title={t(titleKey)} size="xl" showClose="true" t={t}>
      <div>
        <img className="image-container" src={data} />
      </div>
      <div className="spacer"></div>
    </BaseDialog>
  );
};